export default "__VITE_ASSET__BiPgyFAB__"